import React from "react";
import _ from "lodash";

import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import { MESSAGE } from "constants/Message";
import { inputClass } from "helpers/StyleClass";
import { CrossCheckSheetAPI } from "apis";
import { validateEmail } from "helpers/Utils";
import { ROLE } from "./CrossCheckHelper";

class SharedModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: "",
      isSaving: false,
      content: props.content || "",
      items:
        props.content && props.content.split(",").map((item) => _.trim(item)),
    };

    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const content = e.target.value;
    const items = _.uniq(
      content
        .split(/[\n,]/)
        .map((item) => _.trim(item))
        .filter((item) => item !== "")
    );
    this.setState({ content, items });
  }

  async handleConfirm() {
    let { content, items } = this.state;
    const { networkId, sheetId, role, instanceId } = this.props;

    // Allow not setting any emails
    if (!content || content === "") {
      items = [];
    }

    if (items.length > 0 && items.some((item) => !validateEmail(item))) {
      this.setState({
        msg: ["Please provide valid email addresses", MESSAGE.ERROR],
      });
      return;
    }

    this.setState({ isSaving: true, msg: [] });

    try {
      if (role === ROLE.CCS) {
        const { opOK } = await CrossCheckSheetAPI.shareCrossCheckSheet({
          networkId,
          sheetId,
          emails: items,
        });
        if (opOK) {
          this.setState({
            isSaving: false,
            msg: ["Cross check sheet shared successfully", MESSAGE.SUCCESS],
          });
        }
      } else if (role === ROLE.INSTANCE && instanceId) {
        const { opOK } = await CrossCheckSheetAPI.shareCcsInstance({
          networkId,
          sheetId,
          instanceId,
          emails: items,
        });
        if (opOK) {
          this.setState({
            isSaving: false,
            msg: ["Google sheet shared successfully", MESSAGE.SUCCESS],
          });
        }
      }
    } catch (err) {
      this.setState({
        isSaving: false,
        msg: [
          `Failed to share ${role.toLowerCase()}. ${err || ""}.`,
          MESSAGE.ERROR,
        ],
      });
    }
  }

  render() {
    const { handleClose, handleCancel, interactive, role } = this.props;
    const { msg, isSaving, content, items } = this.state;

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        customOverlayStyle={{ zIndex: 100 }}
        width="30%"
        title={`Share ${role}`}
      >
        <div>
          <div className="mb-4">
            <div className="text-gray-600">Shared Emails</div>
            <textarea
              rows={6}
              className={inputClass}
              value={content}
              onChange={this.handleChange}
            ></textarea>
            <div className="text-sm">Separate by "," or line break</div>
            <div className="text-sm">{items.length} items</div>
            {interactive && role === ROLE.CCS && (
              <div className="mt-1 text-sm font-semibold text-orange-600">
                GAM interactive report jobs can only be shared with email
                addresses linked to GAM console accounts.
              </div>
            )}
          </div>

          <ModalFooter
            msg={msg}
            isLoading={isSaving}
            redo={true}
            onClose={handleClose}
            onCancel={handleCancel}
            onConfirm={this.handleConfirm}
          ></ModalFooter>
        </div>
      </ModalWrapper>
    );
  }
}

export default SharedModal;
